/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ecash_Chain_Launch_Date_ExplanationInputs */



/**
* | output |
* | --- |
* | "eCash is a fork of Bitcoin, <br /> launched on Jan 3, 2009" |
*
* @param {Ecash_Chain_Launch_Date_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ecash_chain_launch_date_explanation = /** @type {((inputs?: Ecash_Chain_Launch_Date_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ecash_Chain_Launch_Date_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("eCash is a fork of Bitcoin, <br /> launched on Jan 3, 2009")
});